import { LazyDashboardApp } from "@dashboard/routes/lazy-dashboard-app"
import { createFileRoute, redirect } from "@tanstack/react-router"
import { DashboardShellSkeleton } from "@ui-dashboard/DashboardShellSkeleton"
import { dashboardAppHostRedirectUrl } from "@utils/dashboard-host"
import { currentRequestHostname } from "@utils/dashboard-host-runtime"
import { Suspense } from "react"

export const Route = createFileRoute("/dashboard/contract-maker/$")({
  component: DashboardContractMakerSplatRoute,
  beforeLoad: async ({ location }) => {
    const redirectHref = dashboardAppHostRedirectUrl(await currentRequestHostname(), location.href)
    if (redirectHref) throw redirect({ href: redirectHref })
  },
})

function DashboardContractMakerSplatRoute() {
  return (
    <Suspense fallback={<DashboardShellSkeleton />}>
      <LazyDashboardApp activeSection="contractMaker" />
    </Suspense>
  )
}
